import { POST } from "../API"
let source;
export const contactsOnPlatformAPI = (phone_numbers, onSuccess, onError) => {
    const data = {
        phone_numbers: phone_numbers
    }
    source = POST(`/api/v1/chat/contacts/on_platform`, data, onSuccess, onError, true, source)
}